import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/plus-icon.png'
import _imports_1 from '@/assets/images/icn-favorites-folder-menu.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-18fc51f2")

_pushScopeId("data-v-18fc51f2")
const _hoisted_1 = { class: "mypagefolder-page" }
const _hoisted_2 = { class: "mypagefolder-page-folder-operation-append" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefolder-page-folder-operation-append-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "mypagefolder-page-folder-operation-append-button-text-container" }
const _hoisted_5 = { class: "commonButtonText mypagefolder-page-folder-operation-append-button-text" }
const _hoisted_6 = { class: "mypagefolder-page-folder-operation-delete" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefolder-page-folder-operation-delete-button-image",
  src: _imports_1
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_MyListFolderOperation = _resolveComponent("MyListFolderOperation")
  const _component_FavoritesFolderNameInputDialog = _resolveComponent("FavoritesFolderNameInputDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "mypagefolder-page-folder-operation",
      style: _ctx.styleFolderOperation
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.appendFolderAction(...args))),
          class: "mypagefolder-page-folder-operation-append-button"
        }, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.operationAppendText), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.folderOperationAction(...args))),
          class: "mypagefolder-page-folder-operation-delete-button"
        }, [
          _hoisted_7
        ])
      ])
    ], 4),
    _createVNode("div", {
      class: "mypagefolder-page-body",
      onScrollPassive: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode("div", {
        class: "mypagefolder-page-body-spacer",
        style: _ctx.styleBodySpacer
      }, null, 4),
      _createVNode(_component_CommonRecipeList, {
        key: _ctx.updateDisplayKey,
        recipes: _ctx.recipeList,
        mode: _ctx.deleteMode,
        onSelectRecipe: _ctx.selectRecipeHandler,
        onSelectDelete: _ctx.deleteRecipeHandler
      }, null, 8, ["recipes", "mode", "onSelectRecipe", "onSelectDelete"])
    ], 32),
    _createVNode(_component_MyListFolderOperation, {
      showDialog: _ctx.isShowFolderOperation,
      onSelectClick: _ctx.folderOperationHandler
    }, null, 8, ["showDialog", "onSelectClick"]),
    _createVNode(_component_FavoritesFolderNameInputDialog, {
      showDialog: _ctx.isShowRenameFolderDialog,
      folderName: _ctx.folderName,
      key: _ctx.updateInputFolderNameKey,
      onCloseClick: _ctx.closeRenameFolderDialogHandler,
      onAppendClick: _ctx.renameFolderHandler
    }, null, 8, ["showDialog", "folderName", "onCloseClick", "onAppendClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDialog,
      dialogType: _ctx.generalDialogInfo.type,
      title: _ctx.generalDialogInfo.title,
      message: _ctx.generalDialogInfo.message,
      positiveLabel: _ctx.generalDialogInfo.positiveButtonLabel,
      negativeLabel: _ctx.generalDialogInfo.negativeButtonLabel,
      onPositiveClick: _ctx.positiveHandleGeneralDialog,
      onNegativeClick: _ctx.negativeHandleGeneralDialog,
      onCloseClick: _ctx.closeGeneralDialog
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick", "onCloseClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})